/**
 * Validation Mixin for input fields
 * Note: Vuetify native, not vee-validate as used in other places
 */

export default function useValidation () {
  const vruleFieldRequired = [
    function (v) {
      return !!v || 'Required'
    }
  ]
  const vruleSelectRequired = [
    function (v) {
      return (!!v && Array.isArray(v) && v.length > 0) || 'Required'
    }
  ]
  const vruleValidEmailRequired = [
    v => !!v || 'Email is required',
    v => /.+@.+\..+/.test(v) || 'Email must be valid'
  ]
  const vruleValidPhoneRequired = [
    v => !!v || 'Phone is required',
    v => /^\d{3}-\d{3}-\d{4}$/.test(v) || 'Phone must be valid. (XXX-XXX-XXXX) format'
  ]

  return {
    vruleFieldRequired,
    vruleSelectRequired,
    vruleValidEmailRequired,
    vruleValidPhoneRequired
  }
}
